// @ts-nocheck
import axios from 'axios';
import { BASE_URL } from '../../../../queries/useDataEngine';

export const ResourcePlanningService = {
  //Effort Planning Tab Api's
  getTeamMembersWithEffort: (params, loader = false) =>
    axios.get(`${BASE_URL}/team/effort-management/members`, {
      params,
      loader,
    }),

  getUserTaskDetails: (params, loader = false) =>
    axios.get(`${BASE_URL}/team/effort-management/detail`, {
      params,
      loader,
    }),

  getOpenTaskCount: (params, loader = false) =>
    axios.get(`${BASE_URL}/team/effort-management/opentask-count`, {
      params,
      loader,
    }),

  //Job Board Tab Api's (Status Planning)
  getTemplateTaskList: (params, loader = false) =>
    axios.get(`${BASE_URL}/team/status-management`, {
      params,
      loader,
    }),

  getTaskList: (params, loader = false) =>
    axios.get(`${BASE_URL}/team/status-management/detail`, {
      params,
      loader,
    }),

  //Activity Calendar Tab Api's
  getEventsCount: (payload, loader = false) =>
    axios.post(`${BASE_URL}/get_events_count`, payload, {
      loader,
    }),

  getAllActionEvents: (params, loader = false) =>
    axios.get(`${BASE_URL}/events`, {
      params,
      loader,
    }),

  updateActionEvent: (body, loader = true) =>
    axios.post(`${BASE_URL}/update_alert_field`, body, {
      loader,
    }),

  deleteActionEvent: (params, loader = true) =>
    axios.delete(`${BASE_URL}/events`, {
      params,
      loader,
    }),
};
